import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing an TrendDown icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <TrendDownIcon width={12} />
 */
const TrendDownIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`m 22,12.659 -0.04,4.29 a 1.027,1.027 0 0 1 -1.01,1.01 l
            -4.29,0.04 c -0.55,0 -0.68,-0.31 -0.29,-0.7 l 1.76,-1.76 -5.13,
            -5.13 -3.293,3.288 a 1,1 0 0 1 -1.41,0 l -6,-6 a 1,1 0 0 1 1.41,
            -1.408 l 5.29,5.3 3.29,-3.29 a 1,1 0 0 1 1.41,0 l 5.84,5.84 1.76,
            -1.76 C 21.689,11.98 22,12.109 22,12.659 Z`}
        />
    </SvgIcon>
)

TrendDownIcon.defaultProps = defaultProps

export { TrendDownIcon }
